module.exports = __webpack_public_path__ + "img/thankyou.b0db44d9.svg";